import { render } from "./Child.vue?vue&type=template&id=55030641"
import script from "./Child.vue?vue&type=script&lang=ts"
export * from "./Child.vue?vue&type=script&lang=ts"
script.render = render

export default script